import { render, staticRenderFns } from "./StrategyRiskLevel.vue?vue&type=template&id=b8558df6&"
import script from "./StrategyRiskLevel.vue?vue&type=script&lang=js&"
export * from "./StrategyRiskLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports